import * as actions from './actions'
import {state, collection, computed} from './state'
import {App} from '~/core/app';


const user = App.Controller({
    name: 'user',
    actions,
    state: {
        ...state,
        ...computed
    },
    // collection,
    
}).root(actions)
export default user as typeof user & typeof actions;